import {
  AppBar,
  Box,
  Button,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
  useMediaQuery
} from '@mui/material';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import CV_logo from '../assets/cv-logo.png';
import HeaderBG from '../assets/HeaderBG.webp';
import LogoMobile from '../assets/MobileLogo.png';
import React, { useState } from 'react';
import burger_menu from '../assets/burger_menu.svg';
import homeHero from '../assets/home_header.webp';
import logo from '../assets/Champs_logo.webp';
import logo_black from '../assets/logo_black.webp';
import mobileHeaderBG from '../assets/mobileHeaderBG.png';
import mobileHeaderOctopus from '../assets/mobileOctopus.png';
import mobile_hero from '../assets/mobile_hero.png';
import octopus from '../assets/octopus_header.png';
import ulpoad_work from '../assets/ulpoad_work.png';
import unleash from '../assets/unleash.png';
import uploadWorkMobile from '../assets/uploadBtnMobile.png';
import uploadYourworkBtn from '../assets/uploadYourWorkBtn.webp';
import upload_home from '../assets/upload_home.png';
import upload_home_mobile from '../assets/upload_home_mobile.png';
import menu_bg from '../assets/desktop_champ_bg.png';
import { TroubleshootRounded } from '@mui/icons-material';
import DownloadApp from '../components/downloadPrompt';
import MobileInky from '../assets/mobile_inky.png';
import Download from '../assets/Download.png';
interface HeaderProps {
  scrollToAppDownload: () => void;
}

const Header: React.FC<HeaderProps> = ({ scrollToAppDownload }) => {
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const location = useLocation();
  const isMobile = useMediaQuery('(max-width:600px)');
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState(false);
  const [openPrompt, setOpenPrompt] = useState(false);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (item: string) => {
    setAnchorEl(null);
    if (typeof item === 'string') {
      navigate(`/${item}`);
    }
  };

  const handleScrollToFooter = () => {
    setOpenDialog(true);
  };

  const toggleDrawer = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' || (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  const isHomePage = location.pathname === '/';

  const handleDownload = () => {
    setOpenDialog(true);
  };

  return (
    <>
      <Box
        className="test"
        sx={{
          position: 'relative',
          marginTop: '0'
        }}>
        {openDialog && <DownloadApp openDialog={openDialog} setOpenDialog={setOpenDialog} />}
        {!isMobile && (
          <AppBar position="static" color="transparent" elevation={0} sx={{ marginTop: '20px', marginBottom: '60px' }}>
            <Toolbar sx={{ position: 'relative', zIndex: 1 }}>
              <Box sx={{ flexGrow: 1 }}>
                <NavLink to="/" end>
                  <img
                    src={CV_logo}
                    alt="Logo"
                    style={{
                      height: isMobile ? '57px' : '67px',
                      marginTop: '11px',
                      marginLeft: isMobile ? 0 : '35px'
                    }}
                  />
                </NavLink>
              </Box>

              {/* Desktop Links */}
              <Box sx={{ flexGrow: 1, justifyContent: 'center' }} className="desktop-menu">
                <NavLink
                  to="/"
                  className={({ isActive }) => (isActive ? 'active-link' : 'link')}
                  style={{ color: 'white' }}>
                  <Typography
                    sx={{
                      fontFamily: 'Baloo2',
                      fontSize: '16px',
                      padding: '10px'
                    }}>
                    Home
                  </Typography>
                </NavLink>
                <NavLink
                  to="/champs"
                  className={({ isActive }) => (isActive ? 'active-link' : 'link')}
                  style={{ color: 'white' }}>
                  <Typography sx={{ fontFamily: 'Baloo2' }}>Champs</Typography>
                </NavLink>
                <NavLink
                  to="/contests"
                  className={({ isActive }) => (isActive ? 'active-link' : 'link')}
                  style={{ color: 'white', padding: '18px' }}>
                  <Typography sx={{ fontFamily: 'Baloo2' }}>Challenges</Typography>
                </NavLink>
              </Box>
              <Box sx={{ flexGrow: 3, cursor: 'pointer' }} className="desktop-menu">
                {/* <NavLink
                  to="/register"
                  className={({ isActive }) => (isActive ? 'active-link' : 'active-link')}
                  style={{ padding: '20px' }}>
                  <Typography
                    sx={{
                      padding: '7px 15px',
                      fontFamily: 'Baloo2'
                    }}>
                    Register
                  </Typography>
                </NavLink> */}
                <Button onClick={handleDownload}>
                  <img src={Download} alt={'download'}></img>
                </Button>
              </Box>
            </Toolbar>
          </AppBar>
        )}

        {isMobile && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              marginLeft: '5%',
              mt: 2
            }}
            className="mobile-menu">
            {/* Logo */}
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <NavLink to="/" end>
                <img
                  src={CV_logo}
                  alt="Logo"
                  style={{
                    height: '57px',
                    marginBottom: '15px',
                    marginLeft: '0'
                  }}
                />
              </NavLink>
              <Button
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}>
                <img src={burger_menu} alt="burger-menu"></img>
              </Button>
            </div>

            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                'aria-labelledby': 'basic-button'
              }}
              sx={{
                '& .MuiPaper-root': {
                  width: '150px',
                  height: '200px',
                  background: 'linear-gradient(to bottom, #f9a07d, #e66798)',
                  color: 'white'
                }
              }}>
              <MenuItem onClick={() => handleClose('about')}> About</MenuItem>
              <MenuItem onClick={() => handleClose('cv-policies')}> Privacy Policy</MenuItem>
              <MenuItem onClick={() => handleClose('terms&conditions')}> Terms & conditions</MenuItem>
            </Menu>

            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0'
              }}>
              {/* Navigation Links */}
              <NavLink
                to="/"
                className={({ isActive }) => (isActive ? 'active-link' : 'link')}
                style={{
                  color: isHomePage ? 'white' : '#1F1D3AB2',
                  padding: '7px'
                }}>
                <Typography sx={{ fontFamily: 'Baloo2', fontSize: '12px', color: 'white' }}>Home</Typography>
              </NavLink>

              <NavLink
                to="/champs"
                className={({ isActive }) => (isActive ? 'active-link' : 'link')}
                style={{
                  color: isHomePage ? 'white' : '#1F1D3AB2',
                  padding: '7px'
                }}>
                <Typography sx={{ fontFamily: 'Baloo2', color: 'white', fontSize: '12px' }}>Champs</Typography>
              </NavLink>

              <NavLink
                to="/contests"
                className={({ isActive }) => (isActive ? 'active-link' : 'link')}
                style={{
                  color: isHomePage ? 'white' : '#1F1D3AB2',
                  padding: '7px'
                }}>
                <Typography sx={{ fontFamily: 'Baloo2', color: 'white', fontSize: '12px' }}>Challenges</Typography>
              </NavLink>

              <Button
                onClick={handleDownload}
                style={{
                  color: isHomePage ? 'white' : '#1F1D3AB2',
                  padding: '7px'
                }}>
                <Typography
                  sx={{
                    fontFamily: 'Baloo2',
                    color: 'white',
                    fontWeight: 800,
                    fontSize: '14px',
                    textTransform: 'none'
                  }}>
                  Download
                </Typography>
              </Button>
            </Box>
          </Box>
        )}

        {/* Hero Section Content over the image */}
        {isHomePage && (
          <>
            {
              <Box
                sx={{
                  position: isMobile ? 'absolute' : 'absolute',
                  top: isMobile ? '-18%' : '0',
                  right: isMobile ? '0' : '0px',
                  width: isMobile ? '100%' : '100%',

                  display: 'flex',
                  flexDirection: 'column',
                  objectFit: 'cover',
                  pointerEvents: 'none'
                }}>
                <img src={isMobile ? MobileInky : octopus} alt={'octopus Header'} />
              </Box>
            }
            <Box>
              <Box
                sx={{
                  position: 'relative',
                  height: isMobile ? 'none' : 'calc(100vh - 10rem)',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'left',
                  textAlign: 'left',
                  justifyContent: 'start',
                  padding: '2vw',
                  marginLeft: '5%',
                  marginTop: isMobile ? '5px' : 0
                }}>
                {/* <Box style={{height:"20%"}}></Box> */}
                <Typography
                  sx={{
                    color: 'rgba(255, 242, 237, 0.9)',
                    fontSize: {
                      xs: '18px',
                      sm: '18px',
                      md: '48px',
                      lg: '48px'
                    },
                    fontFamily: 'Bevan',
                    lineHeight: '1.4',
                    textShadow: '2px 2px 16px rgba(158, 22, 53, 0.3)'
                  }}>
                  Where Every <br />
                  <span style={{ whiteSpace: 'pre-line' }}>Child{'\n'}</span>
                  <Box
                    component="span"
                    sx={{
                      color: '#FFDD01',
                      fontSize: isMobile ? '26px' : '70px'
                    }}>
                    {' '}
                    Shines✨
                  </Box>
                </Typography>

                <Typography
                  sx={{
                    fontSize: { xs: '10px', sm: '10px', md: '18px' },
                    fontWeight: 400,
                    color: 'white',
                    mt: isMobile ? 1 : 2,
                    fontFamily: 'Baloo2',
                    textShadow: '2.88px 5.76px 14.4px rgba(158, 22, 53, 0.25)'
                  }}>
                  Unlock skills, Earn Rewards, and Shine <br />
                  Bright in the Champsverse!
                </Typography>

                <Button
                  sx={{
                    mt: isMobile ? 1 : 3,
                    width: { xs: '200px', sm: '40%', md: '30%' },
                    cursor: 'pointer',
                    zIndex: 20, // Ensures button is above other elements
                    position: 'relative', // Keeps it above overlapping elements
                    marginLeft: isMobile ? '-5%' : 0
                  }}
                  onClick={handleScrollToFooter}>
                  <img
                    src={isMobile ? uploadWorkMobile : uploadYourworkBtn}
                    alt="uploadBtn"
                    style={{ width: '100%', height: 'auto' }}
                  />
                </Button>

                {/* {isMobile && (
                  <img
                    alt="mobileHeaderOctopus"
                    src={mobileHeaderOctopus}
                    style={{
                      width: '550px',
                      height: '666px',
                      marginTop: '-15rem',
                      position: 'absolute',
                      top: '204px',
                      left: '-150px',
                      zIndex: 5, // Lower than the button
                      pointerEvents: 'none' // Prevents it from blocking button clicks
                    }}
                  />
                )} */}
              </Box>
            </Box>
          </>
        )}
      </Box>
    </>
  );
};

export default Header;
